import React from "react";

const BackToTop = (props) => {
  return (
    <svg version="1.1" viewBox="0 0 50 50" {...props}>
      <g id="BackToTop" {...props} fill="currentColor">
        <path d="M25,1C11.767,1,1,11.767,1,25s10.767,24,24,24s24-10.767,24-24S38.233,1,25,1z M25,47C12.869,47,3,37.131,3,25   S12.869,3,25,3s22,9.869,22,22S37.131,47,25,47z" />
        <polygon points="10.293,30.293 11.707,31.707 25,18.414 38.293,31.707 39.707,30.293 25,15.586  " />
      </g>
      <g />
    </svg>
  );
};

export default BackToTop;
